<template lang="pug">
.study-result-list-table
  template(v-for='item in studyResultList')
    .study-result-list-table__head.font-bold.text-large
      .study-result-list-table__head__title {{ item.title }}
    table-base.study-result-list-table__table
      table-row-base.study-result-list-table__table__row-header
        table-header-base.study-result-list-table__table__row-header__cell
          slot(name='subjectHeader')
        table-header-base.study-result-list-table__table__row-header__cell
          slot(name='sUnitHeader')
        table-header-base.study-result-list-table__table__row-header__cell
          slot(name='resultHeader')
        table-header-base.study-result-list-table__table__row-header__cell
          slot(name='lastMinuteCheckResultHeader')
        table-header-base.study-result-list-table__table__row-header__cell
          slot(name='resolveResultHeader')
      table-row-base.study-result-list-table__table__row(v-for='(summary, index) in item.summaries', :key='index')
        table-data-base.study-result-list-table__table__row__cell.align-center {{ summary.subject }}
        table-data-base.study-result-list-table__table__row__cell.align-center {{ summary.sUnit }}
        table-data-base.study-result-list-table__table__row__cell.align-center
          button-primary.study-result-list-table__table__row__cell__button(
            @click='resultButtonEvent(summary.id)',
            :data-disabled='!summary.id'
          )
            slot(name='resultButtonLabel')
        table-data-base.study-result-list-table__table__row__cell.align-center
          link-base.study-result-list-table__table__row__cell__link(
            v-if='summary.lastMinuteCheckResult',
            @click='lastMinuteCheckResultLinkEvent(summary.lastMinuteCheckSUnitId)'
          ) {{ summary.lastMinuteCheckResult }}
          .study-result-list-table__table__row__cell__text(v-else) {{ emptyCellLabel }}
        table-data-base.study-result-list-table__table__row__cell.align-center
          link-base.study-result-list-table__table__row__cell__link(
            v-if='summary.resolveResult',
            @click='resolveResultLinkEvent(summary.resolveSUnitId)'
          ) {{ summary.resolveResult }}
          .study-result-list-table__table__row__cell__text(v-else) {{ emptyCellLabel }}
    //- DLリンク
    .study-result-list-table__download
      link-download.study-result-list-table__download__link(
        :img='downloadIconImage',
        @click='downloadEvent(item.originalCurriculumId)'
      )
        slot(name='downloadLabel')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import LinkDownload from '@/components/molecules/student/LinkDownload.vue'
import { StudyResultListType } from '@/models/studyResultListModel'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

/**
 * テスト結果一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ButtonPrimary,
    LinkBase,
    LinkDownload,
  },
})
export default class StudyResultListTable extends Vue {
  // テスト結果一覧表示情報
  @Prop()
  studyResultList!: StudyResultListType

  // 結果ボタン押下イベント
  @Prop()
  resultButtonEvent!: Function

  // 直前チェック結果リンク押下イベント
  @Prop()
  lastMinuteCheckResultLinkEvent!: Function

  // 解きなおし結果リンク押下イベント
  @Prop()
  resolveResultLinkEvent!: Function

  // ダウンロードリンクのアイコン画像
  @Prop()
  downloadIconImage!: string

  // ダウンロードリンク押下時イベント
  @Prop()
  downloadEvent!: Function

  // 未実施の場合に表示する記号
  private emptyCellLabel = CommonCharacterSetting.EMPTY_CELL_LABEL
}
</script>

<style lang="stylus" scoped>
.study-result-list-table
  &__head
    display flex
    padding 5px
    background-color var(--color-study-list-head__background)
    color var(--color-study-list-head__text)

  &__table
    width 100%
    margin-bottom 10px

    &__row-header
      background-color var(--color-study-list-subhead__background)
      color var(--color-study-list-subhead__text)

    &__row, &__row-header
      &__cell
        width 20%
        padding 10px
        border 1px solid var(--color-study-list-table__border)

        &__link
          color var(--color-study-list-table-link__text)
          text-decoration none

  &__download
    display flex
    justify-content flex-end

    &__link
      display flex
      flex-direction column
      align-items flex-end
</style>
